/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Card } from './Card';
import {
    CardFromJSON,
    CardFromJSONTyped,
    CardToJSON,
} from './Card';

/**
 * 
 * @export
 * @interface GetCardOutput
 */
export interface GetCardOutput {
    /**
     * 
     * @type {Card}
     * @memberof GetCardOutput
     */
    card?: Card;
    /**
     * 
     * @type {Error}
     * @memberof GetCardOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetCardOutput interface.
 */
export function instanceOfGetCardOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetCardOutputFromJSON(json: any): GetCardOutput {
    return GetCardOutputFromJSONTyped(json, false);
}

export function GetCardOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'card': !exists(json, 'card') ? undefined : CardFromJSON(json['card']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetCardOutputToJSON(value?: GetCardOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'card': CardToJSON(value.card),
        'error': value.error,
    };
}

